import { Button, CheckboxField, Color, FontWeight, FormButton, Markdown, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-top: 40px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
`;

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const QuestionSupportingText = styled(Typography)`
  color: ${Color.Gray600};
`;

export const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Answer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 24px 20px;
  border: 1px solid ${Color.Gray300};
  background-color: ${Color.White};
`;

export const StyledCheckboxField = styled(CheckboxField)`
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  align-self: baseline;
`;

export const StyledMarkdown = styled(Markdown)`
  strong {
    font-weight: ${FontWeight.Bold};
  }
`;

export const Img = styled.img`
  width: 100%;
`;

export const StyledFormButton = styled(FormButton)`
  white-space: nowrap;
`;
